import { categoriesAction } from "../store/categories/slice";
import { useAppDispatch, useAppSelector } from "../store/hooks";

function useSelecetCategory(category: string | string[]) {
  const dispatch = useAppDispatch();
  const categories = useAppSelector(
    (state) => state.categories.categories.data
  );

  const categoriesdata = categories?.filter(
    (item) => item.category === category
  );
  function selectCategory() {
    if (categoriesdata) {
      dispatch(categoriesAction.setSelectedCategory(categoriesdata[0]));
    }
  }

  return { selectCategory };
}

export default useSelecetCategory;
